import { styled } from '@mui/material';
import Box from '@mui/material/Box';

import { COLORS } from '~/styles/colors';

export const ShadowBox = styled(Box)({
  backgroundColor: COLORS.white,
  margin: '12px 0px 12px 0px',
});
